module.exports = __webpack_public_path__ + "img/barva-zakladni_81_seda.776a93dc.png";